// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type Constructor<T, Arguments extends unknown[] = any[]> = new (
	...arguments_: Arguments
) => T;

export function castTo<T>(
	input: unknown,
	classType: Constructor<T>,
): T | undefined;
export function castTo<T>(
	input: unknown,
	classType: Constructor<T>,
	required: true,
): T;
export function castTo<T>(
	input: unknown,
	classType: Constructor<T>,
	required?: boolean,
): T | undefined {
	if (input instanceof classType) {
		return input;
	}
	if (required) {
		throw new Error();
	} else {
		return undefined;
	}
}
